module.exports = __webpack_public_path__ + "static/media/cancel_flex_proposal.f7ad6925.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/commonImages/cancel_flex_proposal.svg
// module id = 748
// module chunks = 0